module.exports = __webpack_public_path__ + "static/media/sky-castle.035b084a.jpg";